const getFallbackImage = image => `//${image}/?$n_480w$&wid=476&fit=constrain`;

export default getFallbackImage;
